import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SessionState {
  actorId: string | null;
  role: string | null;
  accessToken: string | null;
  setSession: (s: { actorId: string; role: string; accessToken: string }) => void;
  clearSession: () => void;
}

// Bug A fix: persist to localStorage so a full-page reload (typing a feature-page
// URL in the address bar / refresh) keeps the admin logged in instead of bouncing
// back to /login. Only data fields are persisted (partialize); on 401 the response
// interceptor calls clearSession, which writes the nulled state back — so logout /
// token expiry clears storage too. Stale/expired tokens self-heal: rehydrate →
// API 401 → clearSession → /login.
export const useSession = create<SessionState>()(
  persist(
    (set) => ({
      actorId: null,
      role: null,
      accessToken: null,
      setSession: (s) => set(s),
      clearSession: () => set({ actorId: null, role: null, accessToken: null }),
    }),
    {
      name: 'admin-session',
      partialize: (s) => ({ actorId: s.actorId, role: s.role, accessToken: s.accessToken }),
    },
  ),
);
